(
    function (skyward, $, undefined) {
        skyward.form = skyward.form || {};

        skyward.form.initInIframe = function ()
        {
            const fieldElements = $('[id^="SkywardFieldInput-"]');
            fieldElements.not(".codeEEL")
                .off("change", updateAllSkywardFieldInput)
                .on("change", updateAllSkywardFieldInput);

            $("body").on("click", ".js-formInputIcon", function (e) {
                var container = $(this);
                if (container.closest('.jsFormFieldWrapper').find('.jsFieldPopup').length > 0) {

                    var field = container.closest('.jsFormFieldWrapper').find('.jsFieldPopup');
                    if (field.attr('readonly') !== 'readonly') {
                        mapUserFormRelationship(container.closest('.jsFormFieldWrapper'));
                    }

                }
            });

            $("body").on("click", ".jsFormFieldWrapper", function (e) {
                var container = $(this);
                if (container.find('.jsFieldPopup').length > 0) {
                    var field = container.closest('.jsFormFieldWrapper').find('.jsFieldPopup');

                    if (field.attr('readonly') == 'readonly') {

                        mapUserFormRelationship(container);
                    }

                }
            });

            fieldElements.filter("input:radio").on("click", function ()
            {
                if ($(this).length == 0 || $(this).attr('id') == 'undefined' || $(this).attr('id').split('--').length < 2)
                {
                    return;
                }

                var skywardID = $(this).attr('id').split('--')[1];
                var relationshipIdentifierGuid = $(this).attr('id').split('--')[2];
                var relationshipNumber = $(this).attr('id').split('--')[3];
                var formFieldIdentifier = skywardID + '--' + relationshipIdentifierGuid + '--' + relationshipNumber;
                var blankElement = $('[id=SkywardFieldInput--' + formFieldIdentifier + '--BlankValue]');
                var groupElement = $('[id*="' + formFieldIdentifier + '--RadioButtonGroup"]');
                var formViewer = $(this).closest("#ContentDiv");
                if (blankElement.length == 0 || groupElement.length == 0)
                {
                    return;
                }

                var inputValue = $(this).val();
                var originalValue = groupElement.attr('data-original-value');

                if (inputValue === groupElement.val())
                {
                    $(this).prop("checked", false);
                    blankElement.prop("checked", true);

                    groupElement.val(blankElement.val());

                    if (originalValue == "")
                    {
                        groupElement.attr('data-dirty', false);
                        updateSkywardIDTracker(formViewer, false, formFieldIdentifier);
                    }
                    else
                    {
                        groupElement.attr('data-dirty', true);
                        updateSkywardIDTracker(formViewer, true, formFieldIdentifier);
                    }

                    if (blankElement.val() != inputValue)
                    {
                        blankElement.click();
                    }
                }
                else
                {
                    groupElement.val(inputValue);

                    if (inputValue == originalValue && inputValue != blankElement.val())
                    {
                        groupElement.attr('data-dirty', false);
                        updateSkywardIDTracker(formViewer, false, formFieldIdentifier);
                    }
                    else
                    {
                        groupElement.attr('data-dirty', true);
                        updateSkywardIDTracker(formViewer, true, formFieldIdentifier);
                    }
                }
            });

            var textAreaExpand = $('.js-AutoExpand');
            if (textAreaExpand.length > 0)
            {
                skyward.form.updateTextAreaExpandSize(textAreaExpand);
            }

            fieldElements.filter(".codeEEL")
                .each(replaceRelationshipDisplay)
                .on('eelComplete', replaceRelationshipDisplay);
        };

        var init = function ()
        {
            var iFrames = this.find('.FormViewerIFrame').not(".js-ignoreIFrameContents");
            // Hidden iframes mostly don't perform layout, so setupIFrame can only calculate the correct
            // height for the visible ones.
            iFrames.each(function ()
            {
                setupIFrame($(this));
            });
        };
        var setupIFrame = async function (iFrame)
        {
            if (iFrame.data('finished-setup')) {
                return;
            }
            iFrame.data('finished-setup', true);

            try
            {
                await skyward.iframeListener.waitForLoadedAndNonEmpty(iFrame[0]);
            }
            catch { }

            // remove background image
            iFrame.removeClass('loading');

            if (iFrame.hasClass('htmlViewer')) {
                await skyward.iframeListener.setupChangeTracking(iFrame, function (dirty)
                {
                    iFrame.attr("data-dirty", dirty);
                    iFrame.trigger("notifyDirty");

                });
                skyward.iframeListener.initForm(iFrame);

                var formViewerIFrame = $('.FormViewerIFrame').get(0);
                if (formViewerIFrame)
                {
                    var contentArea = $('.FormViewerIFrame').closest('.contentArea').get(0);
                    var dov = $('.FormViewerIFrame').closest('.dataObjectViewer').get(0);

                    if (contentArea && dov)
                    {
                        $('.contentArea').css('position', 'relative');
                        $('.dataObjectViewer').css('position', 'relative');
                        window.addEventListener("resize", resize);
                        resize();
                        function resize() {
                            contentArea = $('.FormViewerIFrame').closest('.contentArea').get(0);
                            dov = $('.FormViewerIFrame').closest('.dataObjectViewer').get(0);
                            $('.FormViewerIFrame').parent().height(contentArea.scrollHeight - dov.offsetTop - formViewerIFrame.offsetTop);
                        }
                    }
                }
            }
        };

        var replaceRelationshipDisplay = function () {
            var codeEEL = $(this);

            var skywardFieldInput = $(this);
            var id = skywardFieldInput[0].id;
            var skywardFieldGuid = id.split('--')[1];
            var relationshipNumber = id.split('--')[3];
            var codeEELValue = skyward.controls.getValue(codeEEL);

            $.ajax({
                url: skyward.global.virtualDir + "Form/FormField/ReplaceRelationshipDisplay",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    uniqueID: skywardFieldGuid,
                    foreignKey: codeEELValue,
                    relationshipNumber: relationshipNumber,
                    formVersionID: $('.formViewerFormVersionID').val()
                },
                success: function (response) {
                    if (response.updateDisplay === true) {
                        codeEEL.find('.codeEELDescription').val(response.displayValue);
                    }
                }
            });
        }

        var updateAllSkywardFieldInput = function (input) {
            var skywardFieldInput = $(this);
            var id = skywardFieldInput[0].id;
            var skywardFieldGuid = id.split('--')[1];
            var relationshipIdentifierGuid = id.split('--')[2];
            var relationshipNumber = id.split('--')[3];
            var formFieldIdentifier = 'SkywardFieldInput--' + skywardFieldGuid + '--' + relationshipIdentifierGuid + '--' + relationshipNumber
            var formViewer = skywardFieldInput.closest("#ContentDiv");
            if (skywardFieldInput.is("select")) {
                var value = skywardFieldInput.find(":selected").val();
                var options = formViewer.find('[id="' + formFieldIdentifier + '"] option[value="' + value + '"]');
                options.prop('selected', true);

                var originalValue = skywardFieldInput.attr('data-original-value');
                var isDirty = String(originalValue).toLowerCase() != String(value).toLowerCase();
                updateSkywardIDTracker(formViewer, isDirty, formFieldIdentifier)
            }
            else if (skywardFieldInput.is('input:checkbox')) {
                var value = skywardFieldInput.is(':checked');
                var inputs = formViewer.find('[id="' + formFieldIdentifier + '"]');
                inputs.prop('checked', value);

                var originalValue = skywardFieldInput.attr('data-original-value');
                var isDirty = String(originalValue).toLowerCase() != String(value).toLowerCase();
                updateSkywardIDTracker(formViewer, isDirty, formFieldIdentifier)
            }

            else if (skywardFieldInput.find('input:radio').length > 0) {
                //This case is here to prevent the default logic from saving the values set in the click function
            }
            else if (
                skywardFieldInput.find('[id="SkywardFieldInput--' + skywardFieldGuid + '-file' + '"]').length > 0 ||
                skywardFieldInput.attr("id").startsWith('SkywardFieldInput--' + skywardFieldGuid + '-----fileUpload') || 
                skywardFieldInput.hasClass('fileUploadElement')
            )
            {
                //no relationships for file upload
                //This case is here to prevent the default logic from saving the values set in the click function
                var image = formViewer.find('[id="SkywardFieldInput--' + skywardFieldGuid + '-image"]');
                $(image).remove();
                var imageIdentifier = 'SkywardFieldInput--' + skywardFieldGuid + '----';
                updateSkywardIDTracker(formViewer, true, imageIdentifier)
            }
            else {
                var value = skywardFieldInput.val();
                var inputs = null;
                if (skywardFieldInput.hasClass('basicEditor')) {
                    formFieldIdentifier = formFieldIdentifier.split('?')[0];
                    inputs = formViewer.find('[id^="' + formFieldIdentifier + '"]');

                }
                else {
                    inputs = formViewer.find('[id="' + formFieldIdentifier + '"]');
                }
                inputs.val(value);
                inputs.trigger('updateEditor');
                inputs.trigger('textAreaResize');
                var originalValue = skywardFieldInput.attr('data-original-value');
                if (originalValue !== undefined)
                {
                    var isDirty = originalValue != value;
                    skywardFieldInput.attr("data-dirty", originalValue != value);
                    updateSkywardIDTracker(formViewer, isDirty, formFieldIdentifier)
                }
            }
        };

        function updateSkywardIDTracker(formViewer, isDirty, formFieldIdentifier) {
            var hiddenList = formViewer.find('#DirtySkywardFieldIDs');
            var hiddenValueString = hiddenList.val();
            var skywardIDList = JSON.parse(hiddenValueString);

            if (isDirty) {
                var index = skywardIDList.indexOf(formFieldIdentifier);
                if (index < 0) {
                    skywardIDList.push(formFieldIdentifier);
                }
            }
            else {
                var index = skywardIDList.indexOf(formFieldIdentifier);
                if (index > -1) {
                    skywardIDList.splice(index, 1);
                }
            }
            hiddenList.val(JSON.stringify(skywardIDList));
        }

        // Calls the ajax action to update tempformrole access checkboxes so they are set if another form is added
        function createSecurityUpdateHandler(isAllUpdate) {
            return function (_event) {
                var elem = $(this);
                var container = elem.closest(".js-panelSelection");
                var url = "";
                if (isAllUpdate) {
                    url = "Form/TempFormRole/UpdateAllSecurityAction";
                }
                else {
                    url = "Form/TempFormRole/UpdateSecurityAction";;
                }
                var data = $(this).data();
                data = $.extend({}, data, { checked: elem.is(":checked") });
                var clickedBrowse = skyward.browse.getContainingBrowse(elem);
                if (!clickedBrowse) {
                    return;
                }
                var selectedRow = elem.closest(".browseRowOptions").data("row");
                skyward.browse.setCurrentRecord(clickedBrowse.browseName, selectedRow);

                data.browseSearchCondition = clickedBrowse.browseSearchCondition;
                data.browseSearchConditionHash = clickedBrowse.browseSearchConditionHash;
                data.userSearchCondition = clickedBrowse.userSearchCondition;
                data.userSearchConditionHash = clickedBrowse.userSearchConditionHash;

                $.ajax(
                    {
                        type: "POST",
                        dataType: "JSON",
                        url: skyward.global.virtualDir + url,
                        data: $.extend({}, data, clickedBrowse.data),
                        success: function (response) {
                            if (response.result) {
                                // Refresh the right browse
                                var rightBrowse = skyward.browse.getContainingBrowse(container.find(".browse.js-panelSelection__right"));
                                if (!rightBrowse) {
                                    return;
                                }
                                /*Change the "0" to "rightBrowse.currentRow" to alter the functionality to have the record after the record added be selected
                                instead of the top record be selected. This will remove the functionality of keeping the current page the closest to the 
                                same that we can. Check with Leah before you change this.*/
                                var rightBrowseCurrentID = skyward.browse.getCurrentRowElement("unlocked", rightBrowse.browseName, 0).data("targetid");
                                var browseGetData =
                                {
                                    seekId: rightBrowseCurrentID
                                };

                                skyward.browse.get(rightBrowse.id, browseGetData);
                            }
                            else {
                                skyward.modalLayer.showDialog("Error", response.errors, [{ text: "Close", icon: "Close" }]);
                            }
                        }
                    });
            };
        }

        function showTreeBrowse() {
            var elem = $(this);
            var lookupModule = elem.data("lookupModule");
            var lookupObject = elem.data("lookupObject");
            var lookupHash = elem.data("lookupHash");
            var relationshipActionUrl = elem.data("relationshipActionUrl");

            var relationshipPathId = "FormFieldVersionFieldPath";
            var relationshipPathControl = $("#" + relationshipPathId);
            var seekPathValue = skyward.controls.getValue(relationshipPathControl);

            var saveButton =
            {
                text: "Select Relationship",
                click: function (event, dialog)
                {
                    var relationshipData = skyward.treebrowse.getSelectedFieldData(dialog.content.find(".treeBrowseContainer"));
                    var relationshipName = relationshipData.fieldName;
                    skyward.controls.setValue(relationshipPathControl, relationshipName || "");
                    dialog.close();
                },
                "icon": "Select",
                additionalClasses: ["saveButton"]
            };
            var cancelButton = { text: "Cancel", click: "close", icon: "Cancel" };

            var treeBrowse = function ()
            {
                return $.ajax(
                {
                    url: skyward.global.virtualDir + relationshipActionUrl,
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        lookupModule: lookupModule,
                        lookupObject: lookupObject,
                        lookupHash: lookupHash,
                        isOneToManySelect: true,
                        pathToRelationship: seekPathValue,
                        seekField: seekPathValue
                    }
                }).done(function (data)
                {
                    var treeBrowseRowChanged = function (event, treeBrowseData, rowData)
                    {
                        var saveButton = menu.footer.find(".saveButton");
                        saveButton.toggle(rowData?.fieldType == "OneToMany");
                    };
                    menu.content.on("treeBrowseRowChange", treeBrowseRowChanged);
                });
            };

            var menu = skyward.modalLayer.showDialog("Select Relationship", treeBrowse, [saveButton, cancelButton],
            {
                anchorTo: elem
            });
        }

        function chooseExistingRelationship()
        {
            var elem = $(this);
            var formID = elem.data("formId")
            var formVersionID = elem.data("formVersionId")
            var formFieldVersionIDRelationship = elem.data("formFieldVersionIdRelationship")

            var okButton =
            {
                text: "Select Relationship",
                click: function (event, dialog)
                {
                    var selectedFormFieldID = skyward.controls.getValue($('#FormFieldID'))
                    skyward.controls.setValue($('#FormFieldIDOverride'), selectedFormFieldID);
                    dialog.close();
                },
                "icon": "Select",
                additionalClasses: ["saveButton"]
            };
            var cancelButton = { text: "Cancel", click: "close", icon: "Cancel" };

            skyward.modalLayer.showDialog(
                "Choose Existing Relationship",
                function ()
                {
                    return $.ajax(
                        {
                            type: "POST",
                            url: skyward.global.virtualDir + "Form" + '/' + "FormFieldVersion" + '/' + "ChooseExistingRelationship",
                            data:
                            {
                                renderType: "ContentOnly",
                                formVersionID: formVersionID,
                                formFieldVersionIDRelationship: formFieldVersionIDRelationship,
                                formID: formID,
                                formFieldID: skyward.controls.getValue($('#FormFieldIDOverride'))
                            }
                        });
                },
                [okButton, cancelButton],
            );
        }

        const buildSpecificationsLegendPopup = function () {
            buildPopup("BuildSpecificationsLegendPopup");
        };

        const buildLegendPopup = function () {
            buildPopup("BuildLegendPopup");
        };

        const buildPopup = function (action) {
            const buildPopup = function () {
                return $.ajax({
                    url: `${skyward.global.virtualDir}Form/FormVersion/${action}`,
                    type: "POST",
                    dataType: "viewparthtml"
                });
            };

            const options =
            {
                anchorTo: $(this)
            };

            skyward.modalLayer.showDialog("Legend", buildPopup, { text: "Close", icon: "Close" }, options);
        };

        /* 
            Map Relationships Popup Logic
        */
        function mapUserFormRelationship(wrapper) {
            var skywardFieldInput = wrapper.find('.jsFieldPopup');

            var id = skywardFieldInput.attr('id');
            var skywardFieldGuid = id.split('--')[1];
            var relationshipIdentifierGuid = id.split('--')[2];
            var relationshipNumber = id.split('--')[3];
            var formFieldIdentifier = 'SkywardFieldInput--' + skywardFieldGuid + '--' + relationshipIdentifierGuid + '--' + relationshipNumber
            var formViewer = skywardFieldInput.closest("#ContentDiv");
            var userFormID = $('.formViewerUserFormID').val();
            var allowMap = false;
            if (skywardFieldInput.attr('data-allow-map')) {
                allowMap = skywardFieldInput.attr('data-allow-map') == "true";
            };

            var data =
            {
                FormFieldSkywardID: skywardFieldGuid,
                RelationshipUniqueID: relationshipIdentifierGuid,
                RelationshipNumber: relationshipNumber,
                UserFormID: userFormID,
                AllowMap: allowMap
            };

            var portal = '';
            if (skywardFieldInput.attr('data-portal'))
            {
                portal = skywardFieldInput.attr('data-portal');
            }                ;
            var buildPopup = function () {
                var values = $.extend({}, {}, data);

                var updates = $('[id^="SkywardFieldRelInput--"]');
                $.each(updates, function (i, item) {
                    data[item.id] = item.value;
                });
                return $.ajax({
                    url: skyward.global.virtualDir + "Form/UserForm/MapRelationship" + portal + "?renderType=contentOnly",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: data
                });
            };

            $.when(buildPopup()).done(function (html) {
                var closeButton = { id: "closeButton", text: "Close", click: function () { dialog.close(); }, icon: "Close" };
                var saveButton = null;
                if (allowMap) {
                    saveButton = {
                        id: "saveUserFormRelationship", text: "Set Relationship", click: saveData, icon: "FieldRelationship", data: data
                    };
                }
                    var options =
                    {
                        anchorTo: wrapper[0],
                        id: skywardFieldInput.attr('id') + "_Popout",
                        draggable: false,
                        initialFocusElement: skywardFieldInput,
                        additionalClasses: 'formFieldIndexModal'
                    };
                var dialog = skyward.modalLayer.showDialog('Relationship Details', html, [saveButton, closeButton], options);

                function saveData() {
                    if (!allowMap) {
                        dialog.close();
                        return;
                    }
                    skyward.dataobjectviewer.getFieldValues(dialog.content).then(fieldValues => {
                        var values = $.extend({}, data, fieldValues);
                        values['warninghash'] = dialog.content.data("warninghash") || "";
                        values['preSaveWarningHash'] = dialog.content.data("preSaveWarningHash") || "";
                        values['editableFields'] = skyward.controls.getEditableFields(dialog.content);
                        return $.ajax({
                            url: skyward.global.virtualDir + "Form/UserForm/SubmitSetRelationship" + portal,
                            type: "POST",
                            dataType: "JSON",
                            data: values,
                            success: function (response)
                            {
                                UpdateRelationships(formViewer, response);
                                dialog.close();
                            }
                        });
                        
                    });                    
                }
            });
        }
        
        function UpdateRelationships(formViewer, responseData) {
            if (responseData && responseData.RelationshipUpdates) {
                for (index in responseData.RelationshipUpdates) {
                    var rel = responseData.RelationshipUpdates[index];
                    var foreignKey = rel.ForeignKey,
                        identifier = rel.Identifier;
                    var inputs = $('#' + identifier);
                    var originalValue;
                    if (inputs.length > 0) {
                        originalValue = inputs.attr('data-original-value');
                    }
                    skyward.controls.setValue(inputs, foreignKey);

                    var isDirty = String(originalValue).toLowerCase() != String(foreignKey).toLowerCase();

                    updateSkywardIDTracker(formViewer, isDirty, identifier)
                }
            }
            if (responseData && responseData.FieldUpdates) {
                for (index in responseData.FieldUpdates) {
                    var field = responseData.FieldUpdates[index];
                    var fieldValue = field.FieldValue,
                        identifier = field.Identifier,
                        isEditable = field.IsEditable;
                    var originalValue; 
                    var inputs = $('[id="' + identifier + '"]');

                    if (inputs.length > 0) {
                        originalValue = inputs.attr('data-original-value');
                    }
                    var originalReadonly = inputs.attr('data-original-readonly');
                    if (isEditable && !originalReadonly) {
                        skyward.controls.enable(inputs);
                        inputs.removeClass('jsFieldPopup');
                    }
                    skyward.controls.setValue(inputs, fieldValue);
                    if (!isEditable && !originalReadonly) {
                        skyward.controls.disable(inputs);
                        inputs.addClass('jsFieldPopup');
                    }
                    var isDirty = String(originalValue).toLowerCase() != String(fieldValue).toLowerCase();

                    updateSkywardIDTracker(formViewer, isDirty, identifier)
                }
            }
        }
        /*
            End Map Relationships Popup Logic
        */

        ////Bootstrap
        var events =
        {
            "updateFormSecurity": createSecurityUpdateHandler(false),
            "updateAllFormSecurity": createSecurityUpdateHandler(true),
            "showTreeBrowse": showTreeBrowse,
            "chooseExistingRelationship": chooseExistingRelationship,
            buildLegendPopup,
            buildSpecificationsLegendPopup,
        };
        skyward.events.registerEvents("form", events);
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);